import "./App.css";
import { useState, useEffect } from "react";
import logo from "./logo-final.svg";

function App() {
  const [activeSection, setActiveSection] = useState("container");
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  console.log(menuOpen);

  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        "container",
        "vision-section",
        "premium-container",
        "health-products",
        "outsourcing-services",
        "rd-section",
        "impact-section",
        "contact-container",
      ];
      const scrollPosition = window.scrollY + 100;

      for (let i = 0; i < sections.length; i++) {
        const section = document.getElementById(sections[i]);
        if (
          section.offsetTop <= scrollPosition &&
          section.offsetTop + section.offsetHeight > scrollPosition
        ) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar-left">
          <img src={logo} alt="Logo" className="logo" />
          <button className="menu-toggle" onClick={toggleMenu}>
            &#9776;
          </button>
        </div>
        <ul className={`navbar-menu ${menuOpen ? "open" : ""}`}>
          <li>
            <a
              href="#container"
              className={activeSection === "container" ? "active" : ""}
            >
              Home
            </a>
          </li>
          <li>
            <a
              href="#vision-section"
              className={activeSection === "vision-section" ? "active" : ""}
            >
              Vision
            </a>
          </li>
          <li>
            <a
              href="#premium-container"
              className={activeSection === "premium-container" ? "active" : ""}
            >
              Premium Carpets
            </a>
          </li>
          <li>
            <a
              href="#health-products"
              className={activeSection === "health-products" ? "active" : ""}
            >
              Health Products
            </a>
          </li>
          <li>
            <a
              href="#outsourcing-services"
              className={
                activeSection === "outsourcing-services" ? "active" : ""
              }
            >
              Outsourcing Services
            </a>
          </li>
          <li>
            <a
              href="#rd-section"
              className={activeSection === "rd-section" ? "active" : ""}
            >
              R&D
            </a>
          </li>
          <li>
            <a
              href="#impact-section"
              className={activeSection === "impact-section" ? "active" : ""}
            >
              Impact
            </a>
          </li>
        </ul>
        <button className="button contact">
          <a
            href="#contact-container"
            className={activeSection === "contact-container" ? "active" : ""}
          >
            Contact Us
          </a>
        </button>
      </nav>
      <div className="hero">
        <div class="container" id="container">
          <div class="text-section">
            <h1>AAA Enterprises International: Nepal's Global Gateway</h1>
            <p>
              Connecting Nepal's finest products and services to the world,
              elevating global presence and fostering economic growth.
            </p>
            <div class="buttons">
              <a href="#premium-container">
                <button class="button explore">Explore Our Offerings</button>
              </a>
              <a href="#contact-container">
                <button class="button partner">Partner With Us</button>
              </a>
            </div>
          </div>

          <div class="image-section">
            <img
              src="https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:1200/https://cdn.gamma.app/f1097ap4ws5hmsi/generated-images/fx2FMPxFc3W0FIk4bJP4q.jpg"
              alt="Nepal Scenic "
            />
          </div>
        </div>
        <div class="vision-section" id="vision-section">
          <h1>
            Our Vision: The <span>Amazon</span> of Nepal Exports
          </h1>

          <div class="vision-step">
            <div class="number-box">1</div>
            <div class="content">
              <h2>Identify Premium Products</h2>
              <p>
                Curate high-quality, unique Nepalese goods that showcase our
                cultural heritage and craftsmanship.
              </p>
            </div>
          </div>

          <div class="vision-step">
            <div class="number-box">2</div>
            <div class="content">
              <h2>Establish Global Partnerships</h2>
              <p>
                Forge strategic alliances with international businesses to
                expand our market reach.
              </p>
            </div>
          </div>

          <div class="vision-step">
            <div class="number-box">3</div>
            <div class="content">
              <h2>Drive Economic Growth</h2>
              <p>
                Create sustainable employment opportunities and contribute to
                Nepal's socio-economic development.
              </p>
            </div>
          </div>
        </div>
        <div class="premium-container" id="premium-container">
          <h1>Premium Carpets: Woven Masterpieces</h1>
          <div class="cards">
            <div class="card">
              <h3>Handcrafted Excellence</h3>
              <p>
                Each carpet is meticulously woven by skilled artisans,
                preserving centuries-old traditions.
              </p>
            </div>
            <div class="card">
              <h3>Sustainable Materials</h3>
              <p>
                We use high-quality, ethically sourced wool and natural dyes for
                eco-friendly luxury.
              </p>
            </div>
            <div class="card">
              <h3>Custom Designs</h3>
              <p>
                Collaborate with our designers to create bespoke carpets
                tailored to your preferences.
              </p>
            </div>
          </div>
        </div>
        <div className="health-products" id="health-products">
          <h1>Health & Longevity Products</h1>
          <div className="products-grid">
            <div className="product-card">
              <h2>Shilajit</h2>
              <p>
                Ancient Himalayan mineral resin, rich in fulvic acid and
                minerals. Boosts energy and supports overall well-being.
              </p>
            </div>

            <div className="product-card">
              <h2>Yarsagumba</h2>
              <p>
                Rare Cordyceps fungus, known for its immune-boosting and
                adaptogenic properties. Harvested sustainably from high-altitude
                regions.
              </p>
            </div>

            <div className="product-card">
              <h2>High-Altitude Herbs</h2>
              <p>
                Potent botanical extracts from the Himalayan region. Carefully
                selected for their therapeutic benefits.
              </p>
            </div>
          </div>
        </div>

        <div className="outsourcing-services" id="outsourcing-services">
          <div className="services-content">
            <div className="services-layout">
              <div className="services-image">
                <img
                  src="https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:1200/https://cdn.gamma.app/f1097ap4ws5hmsi/generated-images/Js2mIrJcV_rPdMEfEhOpo.jpg"
                  alt="Professional office environment"
                  className="office-img"
                />
              </div>
              <div className="services-info">
                <h1>Outsourcing Services: Empowering Global Businesses</h1>
                <div className="services-grid">
                  <div className="service-card">
                    <div className="service-icon">
                      <i className="fas fa-calculator"></i>
                    </div>
                    <h2>Accounting</h2>
                    <p>
                      Precise financial management and reporting services to
                      streamline your operations.
                    </p>
                  </div>

                  <div className="service-card">
                    <div className="service-icon">
                      <i className="fas fa-palette"></i>
                    </div>
                    <h2>Graphic Design</h2>
                    <p>
                      Creative visual solutions tailored to your brand's unique
                      identity and needs.
                    </p>
                  </div>

                  <div className="service-card">
                    <div className="service-icon">
                      <i className="fas fa-truck"></i>
                    </div>
                    <h2>Logistics</h2>
                    <p>
                      Efficient supply chain management and distribution
                      solutions for seamless operations.
                    </p>
                  </div>

                  <div className="service-card">
                    <div className="service-icon">
                      <i className="fas fa-cogs"></i>
                    </div>
                    <h2>Back-Office Support</h2>
                    <p>
                      Comprehensive administrative assistance to enhance your
                      business productivity.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="rd-section" id="rd-section">
          <h1>Research & Development: Innovating for the Future</h1>

          <div class="steps-container">
            <div class="step">
              <div class="step-number">1</div>
              <div class="step-content">
                <h2>Market Analysis</h2>
                <p>
                  Identify emerging trends and untapped opportunities in global
                  markets.
                </p>
              </div>
            </div>

            <div class="step">
              <div class="step-number">2</div>
              <div class="step-content">
                <h2>Product Development</h2>
                <p>
                  Collaborate with local experts to create innovative,
                  high-value Nepalese products.
                </p>
              </div>
            </div>

            <div class="step">
              <div class="step-number">3</div>
              <div class="step-content">
                <h2>Quality Assurance</h2>
                <p>
                  Rigorous testing and refinement to ensure premium quality
                  standards.
                </p>
              </div>
            </div>
            <div class="step">
              <div class="step-number">4</div>
              <div class="step-content">
                <h2>Commercialization</h2>
                <p>
                  Strategic launch and marketing of new products to
                  international markets.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="impact-section" id="impact-section">
          <div className="impact-container">
            <div>
              <h1>Our Impact: Elevating Nepal's Economy</h1>

              <div className="impact-stats">
                <div className="stat-row">
                  <div className="stat-label">Job Creation</div>
                  <div className="stat-value">
                    5,000+ new employment opportunities
                  </div>
                </div>

                <div className="stat-row">
                  <div className="stat-label">Export Growth</div>
                  <div className="stat-value">
                    25% increase in Nepalese exports
                  </div>
                </div>

                <div className="stat-row">
                  <div className="stat-label">Skill Development</div>
                  <div className="stat-value">
                    10,000+ artisans and professionals trained
                  </div>
                </div>

                <div className="stat-row">
                  <div className="stat-label">Rural Development</div>
                  <div className="stat-value">
                    50+ villages economically empowered
                  </div>
                </div>
              </div>
            </div>

            <div class="image-section">
              <img
                src="https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:1200/https://cdn.gamma.app/f1097ap4ws5hmsi/generated-images/xTX1x99cpFvXViqvl5G63.jpg"
                alt="Nepal Economic Growth Charts"
              />
            </div>
          </div>
        </div>

        <div className="contact-container" id="contact-container">
          <div className="text-content">
            <h1>
              Contact Us: <br />
              <span>Let's Build Success Together</span>
            </h1>
            <ul className="contact-links">
              <li onClick={() => toggleAccordion(0)}>
                <span
                  className={`accordion-arrow ${
                    activeAccordion === 0 ? "active" : ""
                  } `}
                >
                  &#9654;
                </span>{" "}
                General Inquiries
                <div
                  className={`accordion-content ${
                    activeAccordion === 0 ? "active" : ""
                  }`}
                >
                  <p>
                    For general information about our company and services,
                    please email info@aaaenterprises.com or call +977 1 4567890.
                  </p>
                </div>
              </li>
              <li onClick={() => toggleAccordion(1)}>
                <span
                  className={`accordion-arrow ${
                    activeAccordion === 1 ? "active" : ""
                  } `}
                >
                  &#9654;
                </span>{" "}
                Partnership Opportunities
                <div
                  className={`accordion-content ${
                    activeAccordion === 1 ? "active" : ""
                  }`}
                >
                  <p>
                    To discuss potential collaborations or business
                    partnerships, contact our Business Development team at
                    partnerships@aaaenterprises.com.
                  </p>
                </div>
              </li>
              <li onClick={() => toggleAccordion(2)}>
                <span
                  className={`accordion-arrow ${
                    activeAccordion === 2 ? "active" : ""
                  } `}
                >
                  &#9654;
                </span>{" "}
                Product Information
                <div
                  className={`accordion-content ${
                    activeAccordion === 2 ? "active" : ""
                  }`}
                >
                  <p>
                    For specific product inquiries or custom orders, reach out
                    to our Sales team at sales@aaaenterprises.com.
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div className="image-section">
            <img
              src="https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:1200/https://cdn.gamma.app/f1097ap4ws5hmsi/generated-images/QokdT_T9OQEtcTZPNcL3W.jpg"
              alt="Professional Contact "
            />
          </div>
        </div>
      </div>
      <div class="footer-design">
        <div class="footer-container">
          <div class="copyright">
            © 2024. All Rights Reserved. Powered By Periwin Solutions
          </div>

          <div class="social-icons">
            <a href="https://periwin.com" target="_blank">
              <i class="fab fa-facebook"></i>
            </a>
            <a href="https://periwin.com" target="_blank">
              <i class="fab fa-instagram"></i>
            </a>
            <a href="https://periwin.com" target="_blank">
              <i class="fab fa-twitter"></i>
            </a>
            <a href="https://periwin.com" target="_blank">
              <i class="fab fa-github"></i>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
